"use strict";

function updateTrimSVG(originalFrontTrimSVG, originalBackTrimSVG) {
  var $select = $(this);

  var paper = $select.val().toLowerCase();
  var svg = '';
  if (paper in window.backSVGPaperMap) {
    svg = window.backSVGPaperMap[paper.toLowerCase()];
  }

  var frontFlipOrDouble = window.fspUtils.getCurrentSide();
  var defaultSvg;

  if (frontFlipOrDouble.substr(0, 4).toLowerCase() == 'flap') {
    setTrimImages(svg ? svg : originalFrontTrimSVG, originalBackTrimSVG);
  } else if (frontFlipOrDouble.substr(0, 6).toLowerCase() == 'double') {
    setTrimImages(originalFrontTrimSVG, svg ? svg : originalBackTrimSVG);
  } else {
    setTrimImages(originalFrontTrimSVG, originalBackTrimSVG);
  }
}

function setTrimImages(front, back) {
  var $frontTrimImg = $('.product-image.front img.trim');
  var $backTrimImg = $('.product-image.back img.trim');

  if ($frontTrimImg.attr('src') != front) {
    $frontTrimImg.attr('src', front);
  }
  if ($backTrimImg.attr('src') != back) {
    $backTrimImg.attr('src', back);
  }
}

$(function() {
  window.backSVGPaperMap = {};
  var commonErrorMsg = 'Variable back SVG depending on paper selection is disabled.';
  var backPapers = window.variableBackSVGPaperMeta.split(',').map(function(paper) {
    return paper.trim().toLowerCase();
  });

  if (backPapers.length != window.variableBackSVGFilenames.length) {
    console.warning('Warning: variable_back_svg_papers and variable_back_svg_filenames meta field values include different number of entries.' +
      ' Some may not be used.');
  }
  var count = Math.min(backPapers.length, window.variableBackSVGFilenames.length);
  for (var i = 0; i < count; i++) {
    window.backSVGPaperMap[backPapers[i].toLowerCase()] = window.variableBackSVGFilenames[i];
  }

  var $paperSelect = window.fspUtils.getPaperSelect();
  if (!$paperSelect) {
    console.error('"Envelope Paper" option not found. ' + commonErrorMsg);
    return;
  }

  var $frontFlipOrDouble = window.fspUtils.getSideSelect();
  if (!$frontFlipOrDouble) {
    console.error('"Front, Flap or Double Sided?" option not found. ' + commonErrorMsg);
    return;
  }

  var $frontTrimImg = $('.product-image.front img.trim');
  var $backTrimImg = $('.product-image.back img.trim');
  var originalFrontTrimSVG = $frontTrimImg.attr('src');
  var originalBackTrimSVG = $backTrimImg.attr('src');

  $paperSelect.on('change', updateTrimSVG.bind(
    $paperSelect[0],
    originalFrontTrimSVG,
    originalBackTrimSVG
  ));

  $frontFlipOrDouble.on('change', updateTrimSVG.bind(
    $paperSelect[0],
    originalFrontTrimSVG,
    originalBackTrimSVG
  ));
});
